module.exports = __webpack_public_path__ + "static/media/general-de-seguros-phone.b497faf1.svg";